// extracted by mini-css-extract-plugin
module.exports = {"main-component":"moveArrow_main-component__bVh6K"};